import { z } from 'zod';
export const bugReportSchema = z.object({
    title: z.string().min(1, 'Title is required').min(5, 'Title must be at least 5 characters'),
    description: z.string().min(1, 'Description is required').min(10, 'Description must be at least 10 characters'),
    includeScreenshot: z.boolean()
});
